"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getInitialState = function getInitialState(data) {
  return {
    sortDescAsc: true,
    filters: {},
    pageIdx: 1,
    data: data ? data : [],
    numberOfTotalRows: data && data.length ? data.length : 0,
    loading: false
  };
};

exports.default = getInitialState;